<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 3 :</span> กิจกรรม
      </div>
      <div class="txt-head black--text mb-2">1. แผนการดำเนินงานโครงการ</div>
      <div class="d-flex justify-end">
        <Button
          :disabled="editMode"
          @onClick="addPlan"
          theme="500"
          prepend-icon="mdi-plus"
          >แผนการดำเนินงาน</Button
        >
      </div>
      <div class="d-flex justify-space-between card-part">
        <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="card-part">
        <div
          v-if="form.spider_chart_3 && form.spider_chart_3.length > 0"
          class="d-flex flex-column gap-12"
        >
          <div
            v-for="(item, i) in form.spider_chart_3"
            :key="i"
            class="d-flex mb-3"
          >
            <div
              class="d-flex align-center"
              style="min-width: 10%; max-width: 10%"
            >
              <v-btn small icon @click="editPlan(i)">
                <Iconify
                  icon="material-symbols:edit"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
              <v-btn small icon @click="deletePlan(i)">
                <Iconify
                  icon="material-symbols:delete"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
            <div class="flex" style="min-width: 10%; max-width: 10%">
              {{ item.year }}
            </div>
            <div class="flex text-break" style="min-width: 15%; max-width: 15%">
              {{ item.name }}
            </div>
            <div class="flex text-break" style="min-width: 25%; max-width: 25%">
              {{ item.plan }}
            </div>
            <div class="flex text-break" style="min-width: 15%; max-width: 15%">
              {{
                Number(item.budget || 0).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) + " บาท"
              }}
            </div>
            <div class="flex" style="min-width: 15%; max-width: 15%">
              <!-- {{ toDateFormat2(item.duration_from) }} ถึง {{ toDateFormat2(item.duration_to) }} -->
                {{ item.duration }}
            </div>
            <div class="flex" style="min-width: 10%; max-width: 10%">
              {{ 
                (Array.isArray(item?.source_topical) ? item.source_topical.join(", ") : "") + 
                (item?.source_topical_other ? (" (" + item.source_topical_other + ")") : "") 
              }}   
            </div>
          </div>
        </div>
        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
      <div v-if="editMode" class="pt-6">
        <div>
          <div class="d-flex gap-16">
            <div class="flex" style="min-width: 35.7%; max-width: 35.7%">
              <div class="mb-1 black--text">ปีที่</div>
              <TextField
                theme="3"
                input-type="number"
                :value="planNew.year"
                @onChange="planNew.year = $event"
              >
              </TextField>
            </div>
            <div style="visibility: hidden">บาท</div>
            <div class="flex" style="min-width: 35.7%; max-width: 35.7%">
              <div class="mb-1 black--text">ชื่อโครงการ</div>
              <TextField
                theme="3"
                :value="planNew.name"
                @onChange="planNew.name = $event"
              >
              </TextField>
            </div>
          </div>
          <div>
            <div class="mb-1 black--text">แผนการดำเนินงาน</div>
            <TextArea
              theme="3"
              height="120"
              :value="planNew.plan"
              @onChange="planNew.plan = $event"
            >
            </TextArea>
          </div>
          <div class="d-flex gap-16">
            <div class="flex">
              <div class="mb-1 black--text">งบประมาณ</div>
              <TextField
                theme="3"
                input-type="number"
                :value="planNew.budget"
                @onChange="planNew.budget = $event"
              >
              </TextField>
            </div>
            <div class="d-flex align-center">บาท</div>
            <div class="d-flex gap-16">
              <div>
                <div class="mb-1 black--text">ระยะเวลา ดำเนินการ</div>
                 <TextField
                  theme="3"
                  :value="planNew.duration"
                  @onChange="planNew.duration = $event"
                >
              </TextField>
                <!-- <DatePicker
                  theme="3"
                  :value="planNew.duration_from"
                  :min-date="todayDate"
                  @onInput="
                    planNew.duration_from = $event;
                    $forceUpdate();
                  "
                >
                </DatePicker> -->
              </div>
              <!-- <div class="d-flex align-center">
                <div class="mb-1 black--text">ถึง</div>
              </div>
              <div>
                <div class="mb-1 black--text" style="visibility: hidden">
                  hidden
                </div>
                <DatePicker
                  theme="3"
                  :value="planNew.duration_to"
                  :min-date="planNew.duration_from"
                  @onInput="
                    planNew.duration_to = $event;
                    $forceUpdate();
                  "
                >
                </DatePicker>
              </div> -->
            </div>
            <div class="flex"></div>
          </div>
          <div>
            <div class="mb-1 black--text">แหล่งทุน</div>
            <v-row style="min-height: 90px;">
              <v-col cols="3" v-for="(item, i) in masterData?.source_topical" :key="i" class="d-flex gap-16">
                <CheckBox
                  style="max-width: unset"
                  :input-value="planNew.source_topical?.includes(item.name)"
                  @onChange="updateSourceTopical(item.name, $event)"
                >
                  {{item.name}}
                </CheckBox>
                <TextField
                  v-if="planNew.source_topical?.includes('อื่นๆ') && item.name ==='อื่นๆ'"
                  :disabled="!planNew.source_topical?.includes('อื่นๆ')"
                  theme="3"
                  :value="planNew.source_topical_other"
                  @onChange="planNew.source_topical_other = $event"
                >
                </TextField>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="
              editMode = false;
              planNew = {};
            "
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextArea from "../../components/input/TextArea";
import TextField from "../../components/input/TextField";
import SwitchInset from "../../components/input/SwitchInset";
import AutoBox from "../../components/input/AutoBox";
import Button from "@/components/input/Button";
import CheckBox from "../../components/input/CheckBox";
import DatePicker from "../../components/input/DatePicker";
import { toDateFormat2, formatNumber } from "@/plugins/global-funcs";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";
import Divcard from "../../components/Divcard.vue";
export default {
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    CheckBox,
    DatePicker,
    TextArea,
  },
  data() {
    return {
      todayDate: null,
      formatNumber,
      toDateFormat2,
      form: {
        spider_chart_3: [],
      },
      editMode: false,
      planNew: {},
      tableHeader: [
        {
          name: "จัดการ",
          width: "10%",
        },
        {
          name: "ปีที่",
          width: "10%",
        },
        {
          name: "ชื่อโครงการ",
          width: "15%",
        },
        {
          name: "แผนการดำเนินงาน",
          width: "25%",
        },
        {
          name: "งบประมาณ",
          width: "15%",
        },
        {
          name: "ระยะเวลา ดำเนินการ",
          width: "15%",
        },
        {
          name: "แหล่งทุน",
          width: "10%",
        },
      ],
    };
  },
  computed: {},
  props: {
    masterData: Object,
    formData: Object,
  },
  created() {
    let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      this.todayDate = yyyy + "-" + mm + "-" + dd;
    eventBus.$on("spiderChart3", () => {
      eventBus.$emit("spiderChart3Send", this.form);
    });
    eventBus.$emit("spiderChart3Send", this.form);
  },
  watch: {
    formData: {
      handler(newValue) {
        console.log("newValue3", newValue);

        this.form = {
          spider_chart_3: Array.isArray(newValue?.spider_chart_3)
            ? newValue?.spider_chart_3
            : [],
        };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    addPlan() {
      this.editMode = true;
      this.planNew = {
        isNew: true,
        source_topical: [],
      };
    },
    savePlan() {
      if (!this.planNew.isNew) {
        this.form.spider_chart_3[this.planNew.temp_index] = this.planNew;
      } else {
        this.form.spider_chart_3?.push(this.planNew);
      }
      this.planNew = {};
      this.editMode = false;
    },
    editPlan(i) {
      this.editMode = false;
      this.planNew = {
        ...this.removeVModel(this.form.spider_chart_3[i]),
        temp_index: i,
        isNew: false,
      };
      this.editMode = true;
      this.$forceUpdate();
    },
    deletePlan(i) {
      this.form.spider_chart_3.splice(i, 1);
      this.$forceUpdate();
    },
    updateSourceTopical(value, checked) {
      if (value === "อื่นๆ") {
        this.planNew.source_topical_other = "";
      }
      const index = this.planNew.source_topical?.indexOf(value);
      if (checked && index === -1) {
        this.planNew.source_topical?.push(value);
      } else if (!checked && index !== -1) {
        this.planNew.source_topical?.splice(index, 1);
      }
    },
  },
};
</script>

<style></style>
